(() => {
  const clocks = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/Amsterdam',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23',year:'numeric',month:'2-digit',day:'2-digit'});
  const clock = () => Object.fromEntries(clocks.formatToParts(new Date()).map(p=>[p.type,p.value]));
  const labels = {
    en:['Order within {time} and we {ship}','ship today','Delivery in {country}'],
    nl:['Bestel binnen {time} en we {ship}','verzenden vandaag','Levering in {country}'],
    de:['Bestelle innerhalb von {time} und wir {ship}','versenden heute','Lieferung nach {country}'],
    da:['Bestil inden {time}, så {ship}','sender vi i dag','Levering i {country}'],
    pl:['Zamów w ciągu {time}, a {ship}','wyślemy dzisiaj','Dostawa do {country}'],
    lv:['Pasūti {time} laikā, un {ship}','nosūtīsim šodien','Piegāde uz {country}'],
    fr:['Commandez sous {time} : {ship}','expédition aujourd’hui','Livraison en {country}'],
    es:['Pide en {time} y {ship}','lo enviamos hoy','Entrega en {country}'],
    it:['Ordina entro {time}: {ship}','spediamo oggi','Consegna in {country}'],
    pt:['Encomenda dentro de {time}: {ship}','enviamos hoje','Entrega em {country}'],
    ja:['{time}以内のご注文で{ship}','本日発送','{country}への配送']
  };
  const icon = type => `<svg class="pdp-delivery-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">${type==='clock'?'<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>':'<path d="M3 8h18v4H3zM5 12v9h14v-9M12 8v13"/><path d="M12 8C4 8 7 1 10 4l2 4c8 0 5-7 2-4l-2 4"/>'}</svg>`;
  function init() {
    const main=document.querySelector('.cc-main-product');
    const data=main?.querySelector('[data-pdp-delivery-config]');
    const output=main?.querySelector('[data-product-delivery-output]');
    if(!data||!output||output.closest('.pdp-delivery-block'))return;
    const config=JSON.parse(data.textContent);
    const lang=document.documentElement.lang.split('-')[0];
    const copy=labels[lang]||labels.en;
    const block=document.createElement('div');block.className='pdp-delivery-block';
    const cutoff=document.createElement('div');cutoff.className='pdp-delivery-row pdp-delivery-cutoff';
    const offers=document.createElement('div');offers.className='pdp-delivery-row pdp-delivery-offers';
    output.before(block);block.append(cutoff,output,offers);
    let cart=null, refreshPending=false, period='';
    const variant=()=>config.variants.find(v=>String(v.id)===String(output.dataset.deliveryVariantId));
    function update() {
      const estimate=output.querySelector('[data-delivery-timeframe]');
      const estimateText=estimate?.querySelector('.card-delivery-timeframe__text');
      if(estimateText&&!estimateText.querySelector('strong')){
        const text=estimateText.textContent.trim(), colon=text.indexOf(':');
        if(colon>=0){const dates=document.createElement('strong');dates.textContent=text.slice(colon+1).trim();estimateText.replaceChildren(document.createTextNode(text.slice(0,colon+1)+' '),dates);}
      }
      if(estimate&&!estimate.querySelector('.pdp-delivery-country')){
        const flag=document.createElement('button');flag.type='button';flag.className='pdp-delivery-country';
        const flagImage=document.createElement('span');flagImage.setAttribute('aria-hidden','true');
        flagImage.textContent=/^[A-Z]{2}$/.test(config.country)?String.fromCodePoint(...[...config.country].map(c=>127397+c.charCodeAt(0))):'';
        const tooltip=document.createElement('span');tooltip.className='pdp-delivery-country__tooltip';tooltip.setAttribute('role','tooltip');
        tooltip.id='delivery-country-tooltip-'+config.sectionId;
        tooltip.textContent=copy[2].replace('{country}',config.countryName);
        flag.setAttribute('aria-label',tooltip.textContent);flag.setAttribute('aria-describedby',tooltip.id);
        flag.append(flagImage,tooltip);
        flag.addEventListener('click',()=>flag.classList.toggle('is-tooltip-open'));
        flag.addEventListener('blur',()=>flag.classList.remove('is-tooltip-open'));
        flag.addEventListener('keydown',event=>{if(event.key==='Escape'){flag.classList.remove('is-tooltip-open');flag.blur();}});
        estimate.append(flag);
      }
      const now=clock(), hour=Number(now.hour);
      const showCutoff=estimate?.dataset.deliveryStock==='in_store'&&hour<14;
      cutoff.hidden=!showCutoff;
      if(showCutoff){
        const minutes=Math.ceil((14*3600-hour*3600-Number(now.minute)*60-Number(now.second))/60);
        const time=`${Math.floor(minutes/60)}h ${minutes%60}m`;
        cutoff.innerHTML=icon('clock')+'<span>'+copy[0].replace('{time}',`<strong>${time}</strong>`).replace('{ship}',`<strong>${copy[1]}</strong>`)+'</span>';
      }
      const html=[];
      for(const {campaign,end} of window.SBSCampaigns.select(config,['delivery'],variant(),cart)){
        const timer=campaign.timerMode!=='None'?`<strong>${window.SBSCampaigns.timerText(end)}</strong>`:'';
        const message=window.SBSCampaigns.message(campaign,variant());
        html.push(message.replaceAll('{timer}',timer));
      }
      const offerHtml=html.length?icon('gift')+'<div>'+html.join('')+'</div>':'';
      if(offers.innerHTML!==offerHtml)offers.innerHTML=offerHtml;
      offers.hidden=!html.length;
      block.hidden=!estimate&&!html.length;
      block.classList.toggle('is-estimate-only',!showCutoff&&!html.length);
      const key=`${now.year}-${now.month}-${now.day}-${hour<14?'before':'after'}`;
      if(period&&period!==key)refresh();period=key;
    }
    async function refresh(){
      if(refreshPending)return;refreshPending=true;
      try{
        const url=new URL(location.href);url.searchParams.set('sections',config.sectionId);url.searchParams.set('_delivery_refresh',Date.now());
        const response=await fetch(url);if(!response.ok)throw Error('Delivery refresh failed');
        const result=await response.json(),doc=new DOMParser().parseFromString(result[config.sectionId],'text/html');
        const fresh=doc.querySelector('[data-product-delivery-variant-data]'),existing=main.querySelector('[data-product-delivery-variant-data]');
        if(fresh&&existing){existing.innerHTML=fresh.innerHTML;const template=[...existing.querySelectorAll('template')].find(t=>t.dataset.variantId===output.dataset.deliveryVariantId);if(template){output.innerHTML=template.content.querySelector('[data-delivery-visible-value]').innerHTML;main.querySelector('[data-delivery-property-input]').value=template.content.querySelector('[data-delivery-property-value]').textContent.trim();}}
        const newData=doc.querySelector('[data-pdp-delivery-config]');if(newData)config.campaigns=JSON.parse(newData.textContent).campaigns;
      }catch(error){console.warn(error)}finally{refreshPending=false;update()}
    }
    async function readCart(){try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js');cart=await response.json();update()}catch(error){console.warn(error)}}
    new MutationObserver(update).observe(output,{childList:true});
    main.addEventListener('on:variant:change',()=>setTimeout(update,0));
    document.addEventListener('on:cart:change',()=>{readCart();refresh()});
    document.addEventListener('on:line-item:change',()=>{readCart();refresh()});
    document.addEventListener('on:cart:add',()=>{readCart();refresh()});
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)update()});
    update();readCart();setInterval(update,1000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
